// Exotic Creations Theme JavaScript

document.addEventListener("DOMContentLoaded", () => {
  // Handle shop link click
  const shopLinks = document.querySelectorAll(".shop-link")
  shopLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault()

      // If we're on the homepage, scroll to products
      if (window.location.pathname === "/" || window.location.pathname === "/index") {
        const productsSection = document.getElementById("all-products")
        if (productsSection) {
          productsSection.scrollIntoView({ behavior: "smooth" })
        }
      } else {
        // If we're on another page, go to homepage and then scroll
        window.location.href = "/#all-products"
      }
    })
  })

  // Mobile menu toggle
  const mobileMenuToggle = document.querySelector(".mobile-menu-toggle")
  const siteNav = document.querySelector(".site-nav")

  if (mobileMenuToggle && siteNav) {
    mobileMenuToggle.addEventListener("click", () => {
      siteNav.classList.toggle("active")
      mobileMenuToggle.classList.toggle("active")
    })
  }

  // Variant selection
  const variantButtons = document.querySelectorAll(".variant-btn")

  variantButtons.forEach((button) => {
    button.addEventListener("click", function () {
      // Find the product card containing this button
      const productCard = this.closest(".product-card")

      // Remove active class from all buttons in this product card
      const buttons = productCard.querySelectorAll(".variant-btn")
      buttons.forEach((btn) => {
        btn.classList.remove("active")
      })

      // Add active class to clicked button
      this.classList.add("active")

      // Update the hidden input with the selected variant ID
      const variantId = this.getAttribute("data-variant-id")
      const variantInput = productCard.querySelector(".variant-id-input")

      if (variantInput && variantId) {
        variantInput.value = variantId
      }
    })
  })

  // Handle product form submissions with standard Shopify form
  const productForms = document.querySelectorAll(".product-form")

  productForms.forEach((form) => {
    form.addEventListener("submit", function (e) {
      // Don't prevent default - let the form submit normally
      // This ensures the cart page works correctly

      // Optional: Add loading state to button
      const submitButton = this.querySelector("button[type='submit']")
      if (submitButton) {
        const originalText = submitButton.textContent
        submitButton.textContent = "Adding..."
        submitButton.disabled = true

        // Re-enable button after a delay (in case form submission is interrupted)
        setTimeout(() => {
          submitButton.textContent = originalText
          submitButton.disabled = false
        }, 3000)
      }
    })
  })

  // Initialize cart count on page load
  updateCartCount()

  // Function to update cart count
  function updateCartCount() {
    fetch("/cart.js", {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        const cartCountElements = document.querySelectorAll(".cart-count")

        cartCountElements.forEach((element) => {
          element.textContent = cart.item_count
        })
      })
      .catch((error) => {
        console.error("Error fetching cart:", error)
      })
  }
})
